import { createAction } from 'Lib/reduxUtils';

import {
  VERIFY_TINDER_U_STATUS,
  VERIFY_TINDER_U_STATUS_ERROR,
  VERIFY_TINDER_U_STATUS_SUCCESS,
} from './constants';

export const verifyTinderUStatus = createAction(VERIFY_TINDER_U_STATUS);
export const verifyTinderUStatusSuccess = createAction(VERIFY_TINDER_U_STATUS_SUCCESS);
export const verifyTinderUStatusError = createAction(VERIFY_TINDER_U_STATUS_ERROR);
